import { Component, ViewChild } from "@angular/core";
import { Webgl2Directive } from "../webgl2/webgl2.directive";
var MainCanvas = (function () {
    function MainCanvas() {
        this.fallback_text = "Loading Canvas...";
    }
    ;
    MainCanvas.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (!this.webgl_context.createContext()) {
            console.log("Unable to initialise Webgl.");
            setTimeout(function () {
                _this.fallback_text = "Unable to initialise Webgl.";
            }, 0);
        }
    };
    MainCanvas.decorators = [
        { type: Component, args: [{
                    selector: "main-canvas",
                    template: "\n    <canvas webgl2 canvas-controller><p>{{fallback_text}}</p></canvas>\n    ",
                    styles: ["\n    canvas {\n        height: 100%;\n        width: 100%;\n        border: none;\n        position: absolute;\n        z-index: 0;\n    }\n    "]
                },] },
    ];
    MainCanvas.ctorParameters = function () { return []; };
    MainCanvas.propDecorators = {
        "webgl_context": [{ type: ViewChild, args: [Webgl2Directive,] },],
    };
    return MainCanvas;
}());
export { MainCanvas };
//# sourceMappingURL=main-canvas.component.js.map